<template>
  <div>
    <el-card shadow="never" class="form-card">
      <div class="clearfix" slot="header">
        <span class="section-title">{{
          $l('INDEX.form_label_material_info') || '物料信息'
        }}</span>
        <el-button
          class="save-btn"
          size="mini"
          type="primary"
          plain
          @click="() => $refs.editForm.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
      <edit-form
        :productLine="productLine"
        :amzSkuMaterialGroup="amzSkuMaterialGroup"
        :materialCode="materialCode || this.baseInfo.materialCode"
        :amzSkuMaterialCode="amzSkuMaterialCode"
        :amzSkuCode="amzSkuCode"
        ref="editForm"
        @loaded="onFormLoaded"
      />
    </el-card>

    <el-row :gutter="24" class="mt-2">
      <el-col :span="8">
        <el-card shadow="never" class="bottom-card">
          <div class="clearfix" slot="header">
            <span class="section-title">{{
              $l('INDEX.table_label_sample_image') || '样张图片'
            }}</span>
            <el-button
              class="save-btn"
              size="mini"
              type="primary"
              plain
              @click="() => $refs.sampleImages.openEditDialog()"
            >
              {{ $l('INDEX.btn_edit_image') || '编辑图片' }}
            </el-button>
          </div>
          <sample-images
            ref="sampleImages"
            :materialCode="materialCode || this.baseInfo.materialCode"
            :amzSkuMaterialCode="amzSkuMaterialCode"
            :amzSkuCode="amzSkuCode"
            @reload="reloadBaseInfo"
          />
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card shadow="never" class="bottom-card">
          <div class="clearfix" slot="header">
            <span class="section-title">{{
              $l('INDEX.table_label_description_file') || '说明文件'
            }}</span>
            <el-button
              class="save-btn"
              size="mini"
              type="primary"
              plain
              @click="() => $refs.docFiles.uploadFile()"
            >
              {{ $l('INDEX.btn_upload_file') || '上传文件' }}
            </el-button>
          </div>
          <doc-files
            ref="docFiles"
            :materialCode="materialCode || this.baseInfo.materialCode"
            :amzSkuMaterialCode="amzSkuMaterialCode"
            :amzSkuCode="amzSkuCode"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EditForm from './components/edit-form'
import SampleImages from './components/sample-images'
import DocFiles from './components/doc-files'
export default {
  name: 'material-materialInfoSet-detail',
  components: {
    EditForm,
    SampleImages,
    DocFiles,
  },
  props: {
    materialCode: { type: String, default: '' },
    amzSkuCode: { type: String, default: '' },
    amzSkuMaterialCode: { type: String, default: '' },
    amzSkuMaterialGroup: { type: String, default: '' },
    productLine: { type: String, default: '' },
  },
  data() {
    return {
      baseInfo: {},
    }
  },
  activated() {
    this.baseInfo = {}
  },
  computed: {},
  methods: {
    onFormLoaded(data) {
      this.baseInfo = data
    },
    reloadBaseInfo() {
      if (this.$refs.editForm) {
        this.$refs.editForm.getData()
      }
    },
    save() {
      this.$refs.editForm.save()
    },
  },
}
</script>
<style lang="scss" scoped>
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
}

.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 18px;
  margin-right: 8px;
}

.section-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.save-btn {
  float: right;
}

.bottom-card {
  min-height: 300px;
}

::v-deep {
  .el-card__body {
    padding: 15px;
  }
  .el-card__header {
    padding: 10px;
  }

  .form-card,
  .bottom-card {
    border: 1px dashed #dcdfe6;
  }
}
</style>
